import { JwtAxios } from '@/packaging';

export const workerApi = {
  async getWorkerStatus(connectionId) {
    const res = await JwtAxios.get(`/Worker/GetWorkerStatus?connectionId=${connectionId}`);
    return res;
  },
  async getWorkList(connectionId) {
    const res = await JwtAxios.get(`/Worker/GetWorkList?connectionId=${connectionId}`);
    return res;
  },
  async changeStatus({ connectionId, type, status }) {
    const res = await JwtAxios.get(
      `/Worker/ChangeStatus?connectionId=${connectionId}&type=${type}&status=${status}`
    );
    return res;
  },
  async GetSocketInfo(searchUser) {
    const res = await JwtAxios.get(`/Worker/SocketInfo?searchUser=${searchUser}`);
    return res;
  },
  async GetWorkInfos(searchUser) {
    const res = await JwtAxios.get(`/Worker/WorkInfos?searchUser=${searchUser}`);
    return res;
  }
};
